import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { routeConfig } from "@router"
import './globalErrorHandler';
import '@ss/mtd-react3/lib/style/theme-yellow.css';
import '@ss/mtd-react/lib/style/yellow.css';
import 'normalize.css';
import './style/index.scss';
import { SourcesContext } from './context';
import { withWatermark, fetchData } from '@/utils'
import HeaderV2 from '@/components/layoutV2/OutHeaderV2';
import Footer from '@/components/layout/footer';
import { HeaderThemeMap } from "@/utils/constant";
import { Loading } from '@ss/mtd-react';
import { CookieBanner } from '@sailor/cookie-manage'
import '@sailor/cookie-manage/dist/lib/index.css'


// const ComponentAPP = withRouter((props) => <App {...props} />);
const bgAniImgs = [
    "https://s3-ap-hongkong.mykeeta.net/static-prod01/com.sankuai.mtd.sailorpx.client-files/compress/background-first-v1.0.jpg",
    "https://s3-ap-hongkong.mykeeta.net/static-prod01/com.sankuai.mtd.sailorpx.client-files/compress/background-second-v1.0.jpg",
    "https://s3-ap-hongkong.mykeeta.net/static-prod01/com.sankuai.mtd.sailorpx.client-files/compress/background-third-v1.0.jpg",
    "https://s3-ap-hongkong.mykeeta.net/static-prod01/com.sankuai.mtd.sailorpx.client-files/compress/background-fourth-v1.0.jpg",
    "https://s3-ap-hongkong.mykeeta.net/static-prod01/com.sankuai.mtd.sailorpx.client-files/compress/background-first-v1.0.jpg"
];
@withRouter
// @withWatermark(true, {
//   type: ['blind'],
//   backgroundColor: ['rgb(255,255,255)', null],
//   refNames: ['container'],
// })
class App extends Component {
  state = {
    showFooter: true,
    activeNavName: '',
    activeAuthCode: '',
    containerStyle: {},
    showBgAni: false,
    slidePosition: 0,
    isTransitioning: false
  };

  async componentDidMount() {

    const history = this.props.history;
    history.listen((location, action) => {

    })
  }

  // header选取
  setActiveNavName = (name) => {
    this.setState({
      activeNavName: name || ''
    })
  }
  // 是否显示底部
  loadDown = (bool) => {
    this.setState({
      showFooter: bool
    })
  }

  resetPV(pageUrl) {
    if (window.Owl) {
      window.Owl.config({
        project: 'com.sankuai.fetc.ss.pxweb',
        pageUrl: pageUrl
      });

      window.Owl.resetPv({
        pageUrl: pageUrl
      });
    }

    // 灵犀上报自定义参数
  }

  changeAppConatinerStyle = (style) => {
    this.setState({
      containerStyle: style
    })
  }

  onRouteChanged(pathname) {
  }

      // 是否显示动态背景图
    changeBgAniShow = bool => {
        this.setState({
            showBgAni: bool,
            slidePosition: 0,
            isTransitioning: false
        });
    };

    // 滑动到下一张图片
    slideNext = (currentBgIndex = 0) => {
        const { slidePosition, isTransitioning } = this.state;

        if (isTransitioning) return;

        // 设置动画状态
        const nextSlidePosition = slidePosition - 20;
        this.setState({
            isTransitioning: true,
            slidePosition: nextSlidePosition
        });

        // 动画结束后处理
        setTimeout(() => {
            // 如果已经到了最后一张图，无动画地回到第一张
            if (nextSlidePosition <= -80) {
                this.setState({
                    isTransitioning: false,
                    slidePosition: 0
                });
            } else {
                this.setState({
                    isTransitioning: false
                });
            }
        }, 1000); // next动画之前
    };

    changeAppConatinerStyle = style => {
        this.setState({
            containerStyle: style
        });
    };

  renderRoute() {
    const loadDown = this.loadDown;
    const changeAppConatinerStyle = this.changeAppConatinerStyle;
    const changeBgAniState = {
        changeBgAniShow: this.changeBgAniShow,
        slideNext: this.slideNext
    };
    return routeConfig.map((route) => {
      return <Route exact={true} key={route.path} path={route.path} render={(props) => {
        this.resetPV(route.caturl || route.path);
        return (
          <>
            <HeaderV2
              theme={route.headerTheme || HeaderThemeMap.OPCITY_LIGHT}
              isOpcity={route.isOpcity}
              isWhiteTheme={route.isWhiteTheme}
              activeNavName={props.location.pathname}
              isSticky={true}
              isNoBlur={route.isNoBlur}
              style={{ boxShadow: '0 0 6px 0 rgba(175,184,200,0.30)', backgroundColor: '#fff' }}
            />
            {/* <route.component {...props} loadDown={loadDown} user={user} activeAuthCode={activeAuthCode} /> */}
            <route.component {...props} loadDown={loadDown} changeAppConatinerStyle={changeAppConatinerStyle} changeBgAniState={changeBgAniState}  />
          </>
        )
      }} />
    })
  }

  setUserInfo = (value) => {
    this.setState({ user: value })
  }

  render() {
    const { user, gallery, typefaces, showFooter, containerStyle, showBgAni} = this.state;
    return (
      <BrowserRouter basename="/assets/">
        <SourcesContext.Provider value={{ gallery, typefaces, user }}>
          <div ref="container" className="app-container watermask" style={containerStyle}>
            <Switch>
              {this.renderRoute()}
              {/* <Redirect to="/marketGuideline" /> */}
            </Switch>
            {
              showFooter && <Footer />
            }
            {showBgAni && (
                <>
                    <div className="bg-ani-container">
                        <div
                            className={`bg-ani-slider ${this.state.isTransitioning
                                    ? ""
                                    : "no-transition"
                                }`}
                            style={{
                                transform: `translateX(${this.state.slidePosition}%)`,
                                width: "500%", // 5张图片的宽度 4 + 1fake
                                display: "flex"
                            }}
                        >
                            {bgAniImgs.map((img, index) => (
                                <div
                                    key={index}
                                    className="bg-ani-slide"
                                    style={{
                                        backgroundImage: `url(${img})`,
                                        backgroundSize: "cover",
                                        // backgroundPosition:
                                        //     "bottom",
                                        width: "20%" // 每张图片占1/4宽度
                                    }}
                                ></div>
                            ))}
                        </div>
                    </div>
                </>
            )}
            <CookieBanner client='pc'/>
          </div>
        </SourcesContext.Provider>
      </BrowserRouter>
    );
  }
}
export default App;
